module.exports = {
  _name: "#show",
  _v: 1,
  mixins: [require("./directives"), require("./style")],
  _attrLookup: {
    show: {
      "#": function(o) {
        this.$style.set(o.el, {
          display: "none"
        });
        return this.$computed.orWatch(o.value, function(value, oldVal) {
          var style;
          style = {
            display: value ? null : "none"
          };
          if (value && o.delay) {
            return this.$nextTick(function() {
              return this.$style.set(o.el, style);
            });
          } else {
            return this.$style.set(o.el, style);
          }
        });
      }
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/#show.js
// module id = 44
// module chunks = 1